module.exports = __webpack_public_path__ + "img/washmachine.6d46f00a.svg";